import { render } from "./TopBarLaunchIcons.vue?vue&type=template&id=42e54517&scoped=true"
import script from "./TopBarLaunchIcons.vue?vue&type=script&lang=js"
export * from "./TopBarLaunchIcons.vue?vue&type=script&lang=js"

import "./TopBarLaunchIcons.vue?vue&type=style&index=0&id=42e54517&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e54517"]])

export default __exports__